import { render, staticRenderFns } from "./MarriageBottomButton.vue?vue&type=template&id=0fc431ac&"
import script from "./MarriageBottomButton.vue?vue&type=script&lang=js&"
export * from "./MarriageBottomButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports